import React from 'react';
import { PublishingPost } from '~/post/types.generated';

import { PostPreviewActions } from '../Actions/PostPreviewActions';
import Analytics from '../Analytics';
import { PostPreviewFooter } from './styles';

type Props = {
  post: PublishingPost;
  isSent: boolean;
  isRetweet: boolean;
  statistics?: boolean;
  channelName: string;
  setOpenModal: () => void;
};

export const Footer = ({
  post,
  isSent,
  isRetweet,
  statistics,
  channelName,
  setOpenModal,
}: Props): JSX.Element => {
  const shouldShowAnalytics = isSent && !isRetweet && statistics;
  return (
    <>
      {shouldShowAnalytics && (
        <PostPreviewFooter>
          <Analytics statistics={statistics} service={channelName} />
        </PostPreviewFooter>
      )}
      <PostPreviewActions post={post} setOpenModal={setOpenModal} />
    </>
  );
};

Footer.defaultProps = {
  isSent: false,
  isRetweet: false,
  statistics: false,
  channelName: false,
  setOpenModal: null,
};
